"use client";
import React, { Component } from "react";
import axios from "axios";
import Router from "next/router";
import { Icon } from "semantic-ui-react";
import PropTypes from "prop-types";
import {
  Config,
  LoginModal,
  SignupModal,
  ForgotpasswordModal,
} from "../components";
import Nav from "./nav";
// Amplify is imported and configured in _app.js
import {
  fetchAuthSession,
  fetchUserAttributes,
  signIn,
  signOut,
  signUp,
  getCurrentUser,
  resetPassword,
  confirmResetPassword,
} from "aws-amplify/auth";
import cookie from "react-cookies";
import {
  addUser,
  updateUser,
  deleteUser,
  getAllUserList,
  updateUserpassword,
} from "../modules/Graphql/usergraphql";
import { getSearchNeighbors } from "../modules/Graphql/neighboraddressserachgraphql";
import {
  getNHmaphomelist,
  MlslistingsAddressSuggestions,
} from "../modules/Graphql/Nhmaphomegraphql";
import { getcitydata } from "../modules/Graphql/cityquestionandanswergraphql";
import { addquestion } from "../modules/Graphql/questionandanswergraphql";
import { addquestion as cityaddquestion } from "../modules/Graphql/cityquestionandanswergraphql";
import { getSchoolinNh } from "../modules/Graphql/neighborhoodboundriesgraphql";
import { addneighborhoodreview } from "../modules/Graphql/neighborhoodreviewgraphql";
import { sendNotification } from "../modules/Graphql/notificationgraphql";
import { editorData } from "../pages/Neighborhood/data.json";
import { editorData as cityeditorData } from "../pages/City/data.json";
import { addcityreview } from "../modules/Graphql/cityreviewgraphql";
import CognitoConfig from "../common/Cognitoconfig";
import path from "path";
import Modal from "react-modal";
// Amplify is configured in _app.js
const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "35%",
  },
  overlay: {
    background: "rgba(0, 0, 0, 0.8)",
  },
};

const customStylesQue = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "30%",
  },
  overlay: {
    background: "rgba(0, 0, 0, 0.8)",
  },
};
var localStorage = require("localStorage");
function startsWithNumber(str) {
  return /^\d/.test(str);
}
function generate_random_string(string_length) {
  let random_string = "";
  let random_ascii;
  let ascii_low = 65;
  let ascii_high = 90;
  for (let i = 0; i < string_length; i++) {
    random_ascii = Math.floor(
      Math.random() * (ascii_high - ascii_low) + ascii_low,
    );
    random_string += String.fromCharCode(random_ascii);
  }
  return random_string;
}
class Layout extends React.PureComponent {
  // static getInitialProps = ({ query, props }) => {
  //   return { query, props };
  // };
  constructor() {
    super();
    this.state = {
      places: [],
      lmodal: false,
      smodal: false,
      fmodal: false,
      address: "",
      neighbordataval: "",
      realtordataval: "",
      homebuyerdataval: "",
      username: "",
      returnemail: "",
      page: "",
      data: "",
      pwd_err_status: false,
      pwd_err_msg: "",
      email_err_status: false,
      email_err_msg: "",
      s_firstname_err_status: false,
      s_firstname_err_msg: "",
      s_lastname_err_status: false,
      s_lastname_err_msg: "",
      s_email_err_status: false,
      s_email_err_msg: "",
      s_password_err_status: false,
      s_password_err_msg: "",
      s_confirmpassword_err_status: false,
      s_confirmpassword_err_msg: "",
      passworderrormsg:
        "Password must be at least 8 characters in legth and contain at least 1 alphabetical character and 1 number. Do not use the $ symbol at the beginning or end of the password",
      f_email_err_status: false,
      f_email_err_msg: "",
      f_veri_err_status: false,
      f_veri_err_msg: "",
      f_email_success_msg: "",
      f_email_success: false,
      f_pass_err_status: false,
      f_pass_err_msg: "",
      query: "",
      nhresults: [],
      results: [],
      homeresults: [],
      loadingtext: "hidden",
      resindex: 5,
      displaydata: "hidden",
      activeSuggestion: 0,
      userInput: "",
      showSuggestions: false,
      address: "",
      verificationdisplay: false,
      newpassword: false,
      f_pass_txt:
        "Password must be at least 8 characters in legth and contain at least 1 alphabetical character and 1 number. Do not use the $ symbol at the beginning or end of the password",
      changemsg: "",
      isnhmap: false,
      ishome: false,
      redirecturl: "",
      isChecked: false,
      emailval: "",
      passval: "",
      user_confirm_status: false,
      gmapsLoaded: false,
      bottomtabwidth: 0,
      first_record: true,
      load_header: false,
      is_suggestion_click: false,
      timer: null,
      is_selected: false,
      is_loaded: true,
      is_mls_calling: false,
      ismodalopen: false,
      ismodalopenque: false,
      ismodalopenreview: false,
      insertmessage: "",
      isAgentChecked: false,
      isFromQues: false,
      isFromReview: false,
      isFromCReview: false,
      isSaving: false,
    };
    /*this.handleAddressChange = this.handleAddressChange.bind(this);
		this.handleAddressSelect = this.handleAddressSelect.bind(this);*/
    this.closeModal = this.closeModal.bind(this);
    this.firstNameChage = this.firstNameChage.bind(this);
    this.onChangeCheckbox = this.onChangeCheckbox.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.onChangeAgentCheckbox = this.onChangeAgentCheckbox.bind(this);
    this.handleCloseIconClick = this.handleCloseIconClick.bind(this);
    this.search = React.createRef();
  }

  newsuggestion_length = 0;
  newsuggestions = [];
  initMap = () => {
    this.setState({
      gmapsLoaded: true,
    });
  };
  componentDidMount = () => {
    document.addEventListener("click", this.handleClickOutside, true);

    // 	window.initMap = this.initMap
    //   const gmapScriptEl = document.createElement(`script`)
    //   gmapScriptEl.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyB_cOLS-j94lQivw9vTrRMkj05o5yR92D8&libraries=places,geometry&callback=initMap"
    //   document.querySelector(`body`).insertAdjacentElement(`beforeend`, gmapScriptEl)
    if (this.props && this.props.address) {
      this.setState({ address: this.props.address });
    }
    if (localStorage.checkbox === "true" && localStorage.email !== "") {
      this.setState({
        isChecked: true,
        emailval: localStorage.email,
        passval: localStorage.password,
      });
    }
    const searchParams = new URLSearchParams(window.location.search);
    let homeurl = window.location.pathname;
    if (homeurl === "/") {
      this.setState({ ishome: true });
    } else {
      this.setState({ ishome: false });
    }
    let searchaddress = searchParams.get("address");

    if (searchaddress === null) {
      this.setState({ isnhmap: false });
      setTimeout(() => this.initMap(), 2000);
      if (localStorage.getItem("redirecturl")) {
        let urls = localStorage.getItem("redirecturl");
        this.setState({ redirecturl: urls });
      }
    } else {
      this.setState({ isnhmap: true });
      setTimeout(() => this.initMap(), 2000);
      localStorage.setItem("redirecturl", window.location.href);
    }

    if (localStorage.getItem("redirecturl")) {
      let urls = localStorage.getItem("redirecturl");
      this.setState({ redirecturl: urls });
    }
    getCurrentUser()
      .then(async (user) => {
        const attributes = await fetchUserAttributes();

        // Use attribute keys instead of array indexes
        const userType = attributes["custom:usertype"];
        const emailVerified = attributes.email_verified;
        const firstName = attributes["custom:firstname"];
        const lastName = attributes["custom:lastname"];
        const email = attributes.email;
        const customId = attributes?.sub;
        const s_id = attributes["custom:id"];
        const pwd = attributes["custom:confirmpassword"];

        const getdata = {
          start: 0,
          limit: 10,
          orderBy: "email",
          order: "ASC",
          fields: [{ name: "email", value: email, operator: "=" }],
        };
        getAllUserList(getdata)
          .then((result) => {
            let userId = result.data.getUser[0].id;

            localStorage.setItem(
              "userdetails",
              JSON.stringify({
                role: userType,
                id: customId,
                status: emailVerified,
                first_name: firstName,
                s_id: s_id,
                last_name: lastName,
                pwd: pwd,
                email: email,
              }),
            );

            // Check email_verified (string in v5)
            if (
              emailVerified === "false" ||
              emailVerified === false ||
              userType != "neighbor"
            ) {
              // window.location.href = '/login'
            }

            if (userType === "neighbor") {
              this.setState({ neighbordataval: Object.values(attributes) }); // Keep for backward compatibility
              this.setState({ username: firstName });
              this.setState({ returnemail: email });
              this.setState({ page: "/AcctNeighbor" });
            }
            if (userType === "realtor") {
              this.setState({ realtordataval: Object.values(attributes) }); // Keep for backward compatibility
              this.setState({ username: firstName });
              this.setState({ returnemail: email });
              this.setState({
                page: `/AcctRealtor`,
              });
            }
            if (userType === "homebuyer") {
              this.setState({ homebuyerdataval: Object.values(attributes) }); // Keep for backward compatibility
              this.setState({ username: firstName });
              this.setState({ returnemail: email });
              this.setState({ page: "/AcctBuyer" });
            }
            if (userType === "webuser") {
              //this.setState({ homebuyerdataval: Object.values(attributes) });
              this.setState({ username: firstName });
              this.setState({ returnemail: email });
              this.setState({ page: "/AcctUser" });
            }
          })
          .catch((err) => {
            // window.location.href = '/login'
          });
      })
      .catch((err) => {
        // window.location.href = '/login'
      });

    window.addEventListener("mousedown", this.pageClick, false);
    window.addEventListener("resize", this.resize.bind(this));
    // this.resize();
  };

  componentDidUpdate(props) {
    // if (this.state.load_header === false && props.is_loading === true) {
    //   this.setState({ load_header: true });
    //   this.componentDidMount();
    // }
  }

  handleClickOutside(event) {
    if (
      event.target.className !== "location-search-input focus-visible" &&
      event.target.className !== "suggestions_name" &&
      event.target.className !== "suggestion-active"
    ) {
      this.setState({ showSuggestions: false });
    } else {
      this.setState({ showSuggestions: true });
    }
  }
  pageClick = (e) => {
    setTimeout(() => this.pageClicksec(), 2000);
  };

  pageClicksec = (e) => {
    if (this.state.displaydata === "visible") {
      this.setState({ displaydata: "hidden" });
    }
  };

  firstNameChage = () => {
    this.setState({
      s_firstname_err_status: false,
      s_firstname_err_msg: "",
    });
  };
  closeModal = () => {
    this.setState({
      lmodal: false,
      smodal: false,
      fmodal: false,
      insertmessage: "",
    });
  };

  getInfo = (searchquery) => {
    const getdata = {
      start: 0,
      limit: 5,
      orderBy: "label",
      order: "ASC",
      fields: [
        {
          name: "label",
          value: searchquery,
          operator: "LIKE",
        },
      ],
    };

    getSearchNeighbors(getdata)
      .then((result) => {
        if (result.data.getSearchNeighbors.length === 0) {
          this.setState({ loading: "none" });
        }
        if (result.data.getSearchNeighbors.length > 0)
          this.setState({ loading: "none" });

        this.setState({
          nhresults: result.data.getSearchNeighbors,
        });
      })
      .catch((error) => {
        console.error(error);
      });
  };

  gethomedataInfo_bkp = (searchquery) => {
    this.setState({ is_loaded: false });
    if (searchquery !== "") {
      const getneighbordata = {
        start: 0,
        limit: 5,
        orderBy: "label",
        order: "ASC",
        fields: [
          {
            name: "label",
            value: searchquery,
            operator: "LIKE",
          },
        ],
      };
      const getdata = {
        start: 0,
        limit: 5,
        orderBy: "UnparsedAddress",
        order: "Like",
        fields: [
          {
            name: "UnparsedAddress",
            value: searchquery,
            operator: "LIKE",
          },
        ],
      };
      const getdatamls = {
        address: searchquery,
      };

      Promise.all([
        MlslistingsAddressSuggestions(getdatamls),
        getNHmaphomelist(getdata),
        getSearchNeighbors(getneighbordata),
      ])
        .then((result) => {
          this.setState({ activeSuggestion: 0 });
          if (this.state.query === "") {
            this.setState({
              results: [],
              homeresults: [],
              is_suggestion_click: false,

              is_loaded: true,
            });
            this.setState({ showSuggestions: false });
          } else {
            let righthomedata = [];
            if (
              result[0].data.MlslistingsAddressSuggestions &&
              result[0].data.MlslistingsAddressSuggestions !== null
            ) {
              righthomedata.push(
                ...result[0].data.MlslistingsAddressSuggestions,
              );
            }
            if (
              result[1].data.getnhmaphome &&
              result[1].data.getnhmaphome !== null &&
              result[1].data.getnhmaphome.length > 0
            ) {
              righthomedata.push(...result[1].data.getnhmaphome);
            }
            this.setState({ homeresults: righthomedata });
            let homeresult = righthomedata;

            if (result[2].data.getSearchNeighbors.length === 0) {
              this.setState({ loading: "none" });
            }
            if (result[2].data.getSearchNeighbors.length > 0)
              this.setState({ loading: "none" });

            // this.setState({
            //   nhresults: result.data.getSearchNeighbors,
            // });
            let nhresultsdata = result[2].data.getSearchNeighbors;
            let finalresult = [...nhresultsdata, ...homeresult];
            if (this.state.query !== "") {
              this.setState({
                results: finalresult,
                is_loaded: true,
              });
            }
          }
          if (!this.state.is_selected) {
            this.setState({ showSuggestions: true });
          }
        })

        .catch((error) => {
          this.setState({
            results: [],
          });

          console.error(error);
        });
    } else {
      this.setState({
        results: [],
        homeresults: [],
        is_suggestion_click: false,
        is_loaded: true,
      });
      this.setState({ showSuggestions: false });
    }
    // getNHmaphomelist(getdata)
    //   .then((result) => {
    //     if (searchquery.length === 0) {
    //       this.setState({
    //         results: [],
    //         homeresults: [],
    //         is_suggestion_click: false,
    //       });
    //       this.setState({ showSuggestions: false });
    //     } else {
    //       this.setState({ homeresults: result.data.getnhmaphome });
    //       let homeresult = result.data.getnhmaphome;
    //       let finalresult = [...nhresultsdata, ...homeresult];
    //       this.setState({
    //         results: finalresult,
    //       });
    //     }
    //   })
    //   .catch((error) => {
    //     this.setState({
    //       results: nhresultsdata,
    //     });
    //     console.error(error);
    //   });
  };

  getMlshomeInfo = (searchquery) => {
    this.setState({ is_loaded: false });
    const getdatamls = {
      address: searchquery,
    };
    MlslistingsAddressSuggestions(getdatamls)
      .then((result) => {
        this.setState({ activeSuggestion: 0 });
        this.setState({ is_loaded: true });
        let mlsresult = result.data.MlslistingsAddressSuggestions;
        if (mlsresult && mlsresult.length > 0) {
          const finalresultmls = [...this.state.results, ...mlsresult];
          this.setState({ results: finalresultmls });
        }
      })
      .catch((error) => {
        this.setState({ activeSuggestion: 0 });
        this.setState({ is_loaded: true });
        console.error(error);
      });
  };

  gethomedataInfo = (searchquery) => {
    this.setState({ is_loaded: false });
    if (searchquery !== "") {
      const getneighbordata = {
        start: 0,
        limit: 5,
        orderBy: "label",
        order: "ASC",
        fields: [
          {
            name: "label",
            value: searchquery,
            operator: "LIKE",
          },
        ],
      };
      const getdata = {
        start: 0,
        limit: 5,
        orderBy: "UnparsedAddress",
        order: "Like",
        fields: [
          {
            name: "UnparsedAddress",
            value: searchquery,
            operator: "LIKE",
          },
        ],
      };
      const getdataschool = {
        start: 0,
        limit: 5,
        orderBy: "School",
        order: "Like",
        fields: [
          {
            name: "School",
            value: searchquery,
            operator: "LIKE",
          },
        ],
      };

      Promise.all([
        getNHmaphomelist(getdata),
        getSearchNeighbors(getneighbordata),
        getSchoolinNh(getdataschool),
      ])
        .then((result) => {
          if (this.state.query === "") {
            this.setState({
              results: [],
              homeresults: [],
              is_suggestion_click: false,
              activeSuggestion: 0,
              is_loaded: true,
            });
            this.setState({ showSuggestions: false });
          } else {
            let righthomedata = [];

            if (
              result[0].data.getnhmaphome &&
              result[0].data.getnhmaphome !== null &&
              result[0].data.getnhmaphome.length > 0
            ) {
              righthomedata.push(...result[0].data.getnhmaphome);
            }
            this.setState({ homeresults: righthomedata });
            let homeresult = righthomedata;

            if (result[1].data.getSearchNeighbors.length >= 0)
              this.setState({ loading: "none" });

            let nhresultsdata = result[1].data.getSearchNeighbors;
            let schoolresultdata = result[2].data.getSchoolinNh;

            let finalresult = [
              ...nhresultsdata,
              ...homeresult,
              ...schoolresultdata,
            ];

            if (this.state.query !== "") {
              this.setState({
                results: finalresult,
                //is_loaded: true,
              });
            }
            if (this.state.is_mls_calling) {
              this.setState({
                is_loaded: false,
              });
            } else {
              this.setState({
                is_loaded: true,
              });
            }
          }
          if (!this.state.is_selected) {
            this.setState({ showSuggestions: true });
          }
        })

        .catch((error) => {
          this.setState({
            results: [],
            sctiveSuggestion: 0,
          });

          console.error(error);
        });
    } else {
      this.setState({
        results: [],
        homeresults: [],
        is_suggestion_click: false,
        is_loaded: true,
      });
      this.setState({ showSuggestions: false });
    }
    // getNHmaphomelist(getdata)
    //   .then((result) => {
    //     if (searchquery.length === 0) {
    //       this.setState({
    //         results: [],
    //         homeresults: [],
    //         is_suggestion_click: false,
    //       });
    //       this.setState({ showSuggestions: false });
    //     } else {
    //       this.setState({ homeresults: result.data.getnhmaphome });
    //       let homeresult = result.data.getnhmaphome;
    //       let finalresult = [...nhresultsdata, ...homeresult];
    //       this.setState({
    //         results: finalresult,
    //       });
    //     }
    //   })
    //   .catch((error) => {
    //     this.setState({
    //       results: nhresultsdata,
    //     });
    //     console.error(error);
    //   });
  };

  resize = () => {
    let place_top = document.getElementById("place_auto_top");

    if (place_top) {
      let width_data = window.getComputedStyle(place_top).width;
      this.setState({ bottomtabwidth: width_data });
    }
  };

  handleInputClick = (e) => {
    this.setState({ showSuggestions: false });
  };

  handleCloseIconClick = () => {
    this.setState({
      results: [],
      homeresults: [],
      is_suggestion_click: false,
      userInput: "",
      address: "",
    });
    this.setState({ showSuggestions: false });
    localStorage.setItem("searchlatuser", 37.63394653644841);
    localStorage.setItem("searchlanguser", -122.25070923144531);
    if (this.props.handleCloseaddress) {
      this.props.handleCloseaddress();
    }
  };

  handleInputChange = (address) => {
    let searchquery = address;
    let place_top = document.getElementById("place_auto_top");
    this.setState({ is_mls_calling: false });
    if (this.state.is_selected) {
      this.setState({ is_selected: false });
    }
    if (searchquery.length === 3) {
      this.setState({ is_suggestion_click: false });
    }
    if (searchquery.length === 0) {
      this.setState({
        results: [],
        homeresults: [],
        is_suggestion_click: false,
      });
      this.setState({ showSuggestions: false });
    }

    if (place_top) {
      let width_data = window.getComputedStyle(place_top).width;
      this.setState({ bottomtabwidth: width_data });
    }

    this.setState({ userInput: address });

    let searchdata = searchquery.replace(/[' ']/g, "%");
    this.setState({ address: address });

    this.setState(
      {
        query: searchquery,
      },
      () => {
        if (searchquery.length === 0) {
          this.setState({
            results: [],
            homeresults: [],
            is_suggestion_click: false,
          });
          this.setState({ showSuggestions: false });
          this.gethomedataInfo("");
        } else if (
          searchquery &&
          searchquery.length > 2 &&
          this.state.is_suggestion_click === false
        ) {
          this.gethomedataInfo(searchquery);

          if (startsWithNumber(searchquery)) {
            this.getMlshomeInfo(searchquery);
            this.setState({ is_mls_calling: true });
          }
          // this.setState({ loading: "block" });
          // clearTimeout(this.state.timer);
          // const newTimer = setTimeout(() => {
          //   // this.getInfo(searchquery);
          //   this.gethomedataInfo(searchquery);
          // }, 500);

          // this.setState({ timer: newTimer });
        }

        // if (searchquery.length === 0) {
        //   this.setState({
        //     results: [],
        //     homeresults: [],
        //     is_suggestion_click: false,
        //   });
        //   this.setState({ showSuggestions: false });
        // }
      },
    );

    if (this.props.nhmap) {
      this.setState({
        address: address,
      });
      this.props.searchhandleAddressChange(address);
    } else {
      this.setState({
        address: address,
      });
      // Router.push('/?address='+address)
    }
  };

  getcitydata = (cityname, red_address, statename) => {
    var getdata = {
      start: 0,
      limit: 1,
      order: "DESC",
      orderBy: "npi",
      fields: [{ name: "postalcity_name", value: cityname, operator: "=" }],
    };
    getcitydata(getdata)
      .then((result) => {
        if (result) {
          if (result.data.getcitydata.length > 0) {
            const cityname = result.data.getcitydata[0].cityfullname;
            window.location.href = `/City/${cityname}`;
          } else if (result.data.getcitydata.length === 0) {
            localStorage.setItem("ispagemain", true);
            window.location.href = "/?address=" + red_address;
          }
        }
      })
      .catch((error) => {
        localStorage.setItem("ispagemain", true);
        window.location.href = "/?address=" + red_address;
      });
  };

  handleKeyChange = (e) => {
    const { activeSuggestion, results } = this.state;

    let pathname = window.location.pathname;
    let userinputdata;

    if (this.state.query === "") {
      this.setState({ showSuggestions: false });
      this.setState({ activeSuggestion: 0 });
    }
    this.setState({ first_record: true });
    let filterdarr = results.filter((x) => {
      if (x.label) {
        return (
          x.label.toLowerCase().indexOf(this.state.query.toLowerCase()) === 0
        );
      } else if (x.UnparsedAddress) {
        return (
          x.UnparsedAddress.toLowerCase().indexOf(
            this.state.query.toLowerCase(),
          ) === 0
        );
      }
    });

    if (filterdarr.length > 0) {
      if (e.keyCode === 13) {
        this.setState({ is_selected: true });
        if (filterdarr.length > 0) {
          this.setState({
            activeSuggestion: 0,
            showSuggestions: false,
            is_loaded: true,
            //userInput: filterdarr[activeSuggestion].label,
          });
          let red_address = this.state.userInput;
          // if (
          //   filterdarr[activeSuggestion] !== undefined &&
          //   filterdarr[activeSuggestion].label &&
          //   filterdarr[activeSuggestion].label !== undefined
          // ) {
          //   red_address = filterdarr[activeSuggestion].label;
          // } else {
          //   red_address =
          //     filterdarr[activeSuggestion].UnparsedAddress +
          //     ", " +
          //     filterdarr[activeSuggestion].City +
          //     ", " +
          //     filterdarr[activeSuggestion].StateOrProvince +
          //     ", " +
          //     filterdarr[activeSuggestion].PostalCode;
          // }

          if (!this.state.isnhmap) {
            let activeval = this.state.userInput.split(",");
            let matchval = activeval;
            if (activeval.length > 0) {
              matchval = activeval[0];
            }
            const uniqueObjects = [
              ...new Map(filterdarr.map((item) => [item.label, item])).values(),
            ];
            let selecteddata = filterdarr.find((o) => {
              if (o.UnparsedAddress) {
                return o.UnparsedAddress === matchval.toString();
              } else {
                return o.label === this.state.userInput;
              }
            });
            if (
              pathname.includes("Neighborhood") ||
              pathname.includes("DetailsListing") ||
              pathname.includes("City")
            ) {
              if (
                selecteddata &&
                selecteddata.ListingKeyNumeric &&
                selecteddata.ListingKeyNumeric !== undefined
              ) {
                window.location.replace(
                  "/DetailsListing/?id=" + selecteddata.ListingKeyNumeric,
                );
              } else if (
                selecteddata &&
                selecteddata.__typename !== undefined &&
                selecteddata.__typename === "searchneighbor"
              ) {
                window.location.replace(
                  "/Neighborhood/" + selecteddata.nhfullname,
                );
              } else if (
                selecteddata &&
                selecteddata._type !== undefined &&
                selecteddata._type.includes("locality")
              ) {
                let cityname = selecteddata.label.split(",")[0];
                let statename = selecteddata.label.split(",")[1].trim();
                this.getcitydata(cityname, red_address, statename);
              } else {
                window.location.replace("/?address=" + red_address);
              }
            } else {
              localStorage.setItem("ispagemain", true);
              window.location.replace("/?address=" + red_address);
            }
          } else {
            this.props.searchOnSelect(red_address);
          }
        }
      }

      // User pressed the up arrow, decrement the index
      else if (e.keyCode === 38) {
        let activesuggestiondata = activeSuggestion - 1;
        let mydiv = document.getElementById(activesuggestiondata);
        if (mydiv && mydiv !== null && mydiv !== undefined) {
          activesuggestiondata = activeSuggestion - 1;
          userinputdata =
            document.getElementById(activesuggestiondata).innerHTML;
          this.setState({ activeSuggestion: activeSuggestion - 1 });
          this.setState({
            userInput: userinputdata,
          });
        }
        this.setState({ is_suggestion_click: true });
      }

      // User pressed the down arrow, increment the index
      else if (e.keyCode === 40) {
        let activesuggestiondata = activeSuggestion + 1;
        let mydiv = document.getElementById(activesuggestiondata);
        if (mydiv && mydiv !== null && mydiv !== undefined) {
          activesuggestiondata = activeSuggestion + 1;
          userinputdata =
            document.getElementById(activesuggestiondata).innerHTML;
          this.setState({ activeSuggestion: activeSuggestion + 1 });
          this.setState({
            userInput: userinputdata,
          });
        }
        this.setState({ is_suggestion_click: true });
      }
    } else {
      if (e.keyCode === 13) {
        this.gethomedataInfo(this.state.query);
      }
    }
  };

  handleSelect = (e, suggestions, type, selectedvalue) => {
    let pathname = window.location.pathname;
    this.setState({ is_selected: true, is_loaded: true });
    localStorage.setItem("prvioussuggestions", JSON.stringify(suggestions));
    this.setState({ userInput: e.currentTarget.innerText });

    let red_address = e.currentTarget.innerText;
    if (this.props.nhmap) {
      this.setState({
        address: red_address,
      });
      if (!this.state.isnhmap) {
        if (
          pathname.includes("Neighborhood") ||
          pathname.includes("DetailsListing") ||
          pathname.includes("City")
        ) {
          if (selectedvalue !== "" && selectedvalue !== undefined) {
            if (type === "street") {
              window.location.replace("/DetailsListing/?id=" + selectedvalue);
            } else if (type === "neighborhood") {
              window.location.replace("/Neighborhood/" + selectedvalue);
            } else if (type === "city") {
              let cityname = selectedvalue.split(",")[0];
              let statename = selectedvalue.split(",")[1].trim();
              this.getcitydata(cityname, red_address, statename);
            } else {
              localStorage.setItem("ispagemain", true);
              window.location.replace("/?address=" + selectedvalue);
            }
          }
        } else {
          localStorage.setItem("ispagemain", true);
          window.location.replace("/?address=" + red_address);
        }
      } else {
        this.props.searchOnSelect(red_address);
      }
      //this.props.searchOnSelect(red_address)
    } else {
      cookie.remove("map-cookie");

      this.setState({
        address: red_address,
      });
      if (!this.state.isnhmap) {
        if (
          pathname.includes("Neighborhood") ||
          pathname.includes("DetailsListing") ||
          pathname.includes("City")
        ) {
          if (selectedvalue !== "" && selectedvalue !== undefined) {
            if (type === "street") {
              window.location.replace("/DetailsListing/?id=" + selectedvalue);
            } else if (type === "neighborhood") {
              window.location.replace("/Neighborhood/" + selectedvalue);
            } else if (type === "city") {
              let cityname = selectedvalue.split(",")[0];
              let statename = selectedvalue.split(",")[1].trim();
              this.getcitydata(cityname, red_address, statename);
            } else {
              localStorage.setItem("ispagemain", true);
              window.location.replace("/?address=" + selectedvalue);
            }
          }
        } else {
          localStorage.setItem("ispagemain", true);
          window.location.replace("/?address=" + red_address);
        }
      } else {
        this.props.searchOnSelect(red_address);
      }

      //window.location.href="/?address="+red_address;
    }
    this.setState({ showSuggestions: false });
    this.setState({ activeSuggestion: 0 });
    this.setState({ is_suggestion_click: true });
    //window.location.replace('/?address='+red_address);
  };

  handleOutsideClick = (event) => {
    if (this.search.current && !this.ref.current.contains(event.target)) {
      if (this.state.showSuggestions === true) {
        this.setState({ showSuggestions: false });
      }
    }
  };

  /*handleAddressSelect = (address) =>  {
		this.setState({displaydata:"hidden"});
		if(this.props.nhmap)
		{
			this.setState({
				address: address,
			});
			this.props.searchOnSelect(address)
		}
		else
		{
			cookie.remove('map-cookie');
			this.setState({
				address: address,
			});
			window.location.href="/?address="+address;
		}
	}*/

  homeClick = (url) => {
    // localStorage.setItem("ispagemain", true);
  };

  buttonClick = (e) => {
    let name = e.target.name;
    let { lmodal, smodal } = this.state;
    if (name === "signup") {
      this.setState({
        smodal: !smodal,
      });
    } else if (name === "myaccount") {
      this.setState({
        smodal: false,
        lmodal: false,
      });
    } else if (name === "login") {
      this.setState({
        lmodal: !lmodal,
      });
    } else if (name === "logout") {
      let logoutuser = localStorage.getItem("searchuser");
      localStorage.setItem("logoutuser", logoutuser);
      localStorage.removeItem("auth_query");
      localStorage.removeItem("objAddHomeSearch");
      localStorage.removeItem("personal_data");
      localStorage.removeItem("is_pre_display");
      localStorage.removeItem("lastvisitedhome");
      localStorage.removeItem("lastvisitednh");
      localStorage.removeItem("cityname");
      localStorage.removeItem("commData");
      localStorage.removeItem("detaillist");
      localStorage.removeItem("detailnh");
      localStorage.removeItem("globaluserid");
      localStorage.removeItem("is_already_perosnal");
      localStorage.removeItem("is_fill_personalize");
      localStorage.removeItem("is_first");
      localStorage.removeItem("is_not_perosnal");
      localStorage.removeItem("neighborhoodId");
      localStorage.removeItem("nhdetails");
      localStorage.removeItem("userdetails");
      localStorage.removeItem("userId");
      localStorage.removeItem("previous_url");
      localStorage.removeItem("savedhomeclickdata");
      localStorage.removeItem("savednhclickdata");
      localStorage.removeItem("savedcityclickdata");
      localStorage.removeItem("prvioussuggestions");
      localStorage.removeItem("is_user_skip_ride");
      signOut()
        .then((data) => {})
        .catch((err) => {});
      // window.location.reload();
      //localStorage.clear();
      if (this.props.nhmap) {
        location.reload();
      } else {
        window.location.href = "/";
      }
      //localStorage.setItem("searchlatuser", "");
      //localStorage.setItem("searchlanguser", "");
      //localStorage.setItem("searchlat", "");
      //localStorage.setItem("searchlang", "");
      //localStorage.setItem("objPersonalSearch", "");
      //localStorage.setItem("userdetails", "");
      localStorage.setItem("globaluserid", "");
    }
  };

  nextModal = (e) => {
    let id = e.target.id;

    if (id === "smodal") {
      this.setState({ smodal: false, lmodal: true, fmodal: false });
    } else if (id === "fmodal") {
      this.setState({ smodal: false, lmodal: false, fmodal: true });
    } else {
      this.setState({ smodal: true, lmodal: false, fmodal: false });
    }
  };

  // forgotModal = (e) =>{
  // 	this.setState({smodal:false, lmodal:false, fmodal:true});
  // }

  handleSubmit = (values) => {
    this.setState({ insertmessage: "" });
    let id = values.id;
    let urls;
    // if(localStorage.getItem('redirecturl')){
    // 	urls = localStorage.getItem('redirecturl');
    // }else{
    urls = "/NhMap/";
    // }
    // this.setState({smodal:false,lmodal:false});
    localStorage.setItem("auth_query", JSON.stringify(values));

    // Router.push({pathname: '/login',asPath: '/login', query: values},'/login');
    if (id === "lmodal") {
      this.setState({
        email_err_status: false,
        email_err_msg: "",
        pwd_err_status: false,
        pwd_err_msg: "",
      });
      var flag = 1;
      if (values && values.email === "") {
        flag = 0;
        this.setState({
          email_err_status: true,
          email_err_msg: "Email is required!",
        });
      }
      if (values && values.password === "") {
        flag = 0;
        this.setState({
          pwd_err_status: true,
          pwd_err_msg: "Password is required!",
        });
      }
      if (flag === 1) {
        this.setState({ isSaving: true });
        const username = values.email;
        const password = values.password;
        const isChecked = this.state.isChecked;
        if (isChecked && username !== "") {
          localStorage.setItem("email", username);
          localStorage.setItem("password", password);
          localStorage.setItem("checkbox", isChecked);
        }
        signIn({
          username,
          password,
        })
          .then(async () => {
            const session = await fetchAuthSession();
            const attributes = session.tokens?.idToken?.payload || {};
            if (attributes?.email_verified === true) {
              this.setState({
                err_status: false,
                err_msg: "",
                isSaving: false,
              });

              // if (registertype[0] === "homebuyer") {
              //   //window.location.href = urls;
              //   location.reload();
              // } else if (registertype[0] === "realtor") {
              //   //window.location.href = urls;
              //   location.reload();
              // } else if (registertype[0] === "neighbor") {
              //   //window.location.href = urls;
              //   location.reload();
              // } else {
              //   this.setState({
              //     verifymessage: "Please verify your email first",
              //   });
              // }

              if (
                attributes["custom:usertype"] &&
                attributes["custom:usertype"] != ""
              ) {
                //window.location.href = urls;
                // location.reload();
                setTimeout(() => {
                  this.redirectTolastpage();
                }, 2000);
              } else {
                this.setState({
                  verifymessage: "Please verify your email first",
                });
              }

              // const getdata = {
              //     "start":  0,
              //     "limit":  10,
              //     "orderBy":  "email",
              //     "order":  "ASC",
              //     "fields":  [{"name":"email","value":user.attributes.email,"operator":"="}]
              // }
              // getAllUserList(getdata)
              //     .then(
              //         result => {
              //             this.setState({data:result.data.getUser})

              //             this.state.data.map((item,index)=>{

              //             if(registertype[0] === 'homebuyer'){
              //                 window.location.href = '/homesearch'
              //             }else if (registertype[0] ==='realtor'){
              //                 if(item.realEstateFirm != ''){
              //                     window.location.href = '/AcctRealtor'
              //                 }else{
              //                     window.location.href = '/RegRealtors'
              //                 }

              //             }else if (registertype[0] === 'neighbor'){
              //                 window.location.href = '/RegNeighbor'
              //             }else{
              //                 this.setState({
              //                     verifymessage: "Please verify your email first"
              //                 })
              //             }
              //         })
              //         }).catch(error => { console.error(error); });
            }
          })
          .catch((err) => {
            this.setState({ isSaving: false });
            if (err) {
              if (err.message === "User is not confirmed.") {
                this.setState({
                  message: err.message,
                  pwd_err_status: false,
                  //pwd_err_msg: err.message,
                  user_confirm_status: true,
                });
              } else {
                this.setState({
                  message: err.message,
                  pwd_err_status: true,
                  pwd_err_msg: err.message,
                  user_confirm_status: false,
                });
              }
            }
          });
      }
    } else if (id === "smodal") {
      localStorage.setItem("auth_query", JSON.stringify(values));
      let regularExpression = new RegExp("^(?=.*[a-z])(?=.*[0-9])(?=.{8,})");
      let emailregularExpression = new RegExp(
        "^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]$",
      );

      var flag = 1;
      if (values && values.first_name === "") {
        flag = 0;
        this.setState({
          s_firstname_err_status: true,
          s_firstname_err_msg: "First Name is required!",
        });
      } else if (values && values.first_name.length < 3) {
        flag = 0;
        this.setState({
          s_firstname_err_status: true,
          s_firstname_err_msg: "Minimum 3 characters!",
        });
      } else if (values && values.first_name.length > 15) {
        flag = 0;
        this.setState({
          s_firstname_err_status: true,
          s_firstname_err_msg: "Maximum 15 characters!",
        });
      } else {
        this.setState({
          s_firstname_err_status: false,
          s_firstname_err_msg: "",
        });
      }

      if (values && values.last_name === "") {
        flag = 0;
        this.setState({
          s_lastname_err_status: true,
          s_lastname_err_msg: "Last Name is required!",
        });
      } else if (values && values.last_name && values.last_name.length < 3) {
        flag = 0;
        this.setState({
          s_lastname_err_status: true,
          s_lastname_err_msg: "Minimum 3 characters!",
        });
      } else if (values && values.last_name && values.last_name.length > 15) {
        flag = 0;
        this.setState({
          s_lastname_err_status: true,
          s_lastname_err_msg: "Maximum 15 characters!",
        });
      } else {
        this.setState({
          s_lastname_err_status: false,
          s_lastname_err_msg: "",
        });
      }

      if (values && values.email === "") {
        flag = 0;
        this.setState({
          s_email_err_status: true,
          s_email_err_msg: "Email is required!",
        });
      } else if (!emailregularExpression.test(values.email)) {
        this.setState({
          s_email_err_status: true,
          s_email_err_msg: "Please enter valid email!",
        });
      } else {
        this.setState({
          s_email_err_status: false,
          s_email_err_msg: "",
        });
      }

      if (values && values.password === "") {
        flag = 0;
        this.setState({
          s_password_err_status: true,
          s_password_err_msg: "Password is required!",
        });
      } else if (!regularExpression.test(values.password)) {
        flag = 0;
        this.setState({
          s_password_err_status: true,
          s_password_err_msg: this.state.passworderrormsg,
        });
      } else if (values.password.slice(-1) === "$") {
        flag = 0;
        this.setState({
          s_password_err_status: true,
          s_password_err_msg:
            "Do not use the $ symbol at the beginning or end of the password",
        });
      } else {
        this.setState({
          s_password_err_status: false,
          s_password_err_msg: "",
        });
      }
      if (values && values.confirmpassword === "") {
        flag = 0;
        this.setState({
          s_confirmpassword_err_status: true,
          s_confirmpassword_err_msg: "Confirm Password is required!",
        });
      } else if (values.password !== values.confirmpassword) {
        flag = 0;
        this.setState({
          s_confirmpassword_err_status: true,
          s_confirmpassword_err_msg: "Password not matching",
        });
      } else {
        this.setState({
          s_confirmpassword_err_status: false,
          s_confirmpassword_err_msg: "",
        });
      }

      if (flag === 1) {
        {
          this.setState({ isSaving: true });
          //if (event) event.preventDefault()
          const email = values.email;
          const confirmpassword = values.confirmpassword;
          const firstname = values.first_name;
          const lastname = values.last_name;
          const password = values.password;
          const displayname = values.display_name;
          const isagent = this.state.isAgentChecked ? "true" : "false";

          //const { email, password } = this.state
          signUp({
            username: email,
            password: confirmpassword,
            options: {
              userAttributes: {
                "custom:usertype": this.state.isAgentChecked
                  ? "realtor"
                  : "webuser",
                "custom:firstname": firstname,
                "custom:lastname": lastname,
                "custom:confirmpassword": password,
                "custom:id": generate_random_string(15),
              },
            },
          })
            .then((data) => {
              const isfromreview = localStorage.getItem("isfromnhreview");
              const isfromCityreview = localStorage.getItem("isfromCityreview");
              if (
                isfromreview &&
                isfromreview !== null &&
                isfromreview != undefined
              ) {
                this.setState({
                  isFromReview: true,
                  ismodalopenreview: true,
                  smodal: false,
                  ismodalopenque: false,
                });
              }
              if (
                isfromCityreview &&
                isfromCityreview !== null &&
                isfromCityreview != undefined
              ) {
                this.setState({
                  isFromCReview: true,
                  ismodalopenreview: true,
                  smodal: false,
                  ismodalopenque: false,
                });
              }
              const adddata = {
                type: this.state.isAgentChecked ? "realtor" : "webuser",
                firstName: firstname,
                lastName: lastname,
                email: email,
                password: confirmpassword,
                aboutMe: "",
                numberNeighborhoodsReviewed: 0,
                like: 0,
                questionsAnswered: 0,
                point: 0,
                realEstateFirm: "",
                license: "",
                phone: "",
                isagent: isagent,
                ishomebuyer: "false",
                ishomeseller: "false",
                isneighbor: "false",
                istopagent: "false",
                userimage: "",
                streetaddress: "",
                city: "",
                state: "",
                zip: "",
                caption: "",
                displayname: displayname || "",
              };

              addUser(adddata)
                .then((result) => {
                  if (result.data.createUser.success === true) {
                    this.setState({ isSaving: false });
                    let fromques = false;
                    const isfromques = localStorage.getItem("isfromques");
                    if (
                      isfromques &&
                      isfromques !== null &&
                      isfromques != undefined
                    ) {
                      fromques = true;
                      this.setState({
                        smodal: false,
                        isFromQues: fromques,
                        ismodalopenque: true,
                        ismodalopenreview: false,
                      });
                    } else {
                      this.setState({
                        smodal: false,
                        //insertmessage: result.data.createUser.message,
                        ismodalopen: true,
                      });

                      // setTimeout(() => {
                      //   this.setState({
                      //     ismodalopen: false,
                      //   });
                      // }, 4000);
                    }
                    localStorage.setItem("is_first", true);
                    setTimeout(() => {
                      this.refiectTonhpage(email);
                    }, 500);

                    //window.location.href = "/login";
                  } else if (result.data.createUser.success === false) {
                    const msg = result.data.createUser.message;
                    const sqlmsg = msg.split("sqlMessage=")[1];
                    const errmsg = sqlmsg.split(", sqlState=")[0];
                    this.setState({ insertmessage: errmsg, isSaving: false });
                  }
                })
                .catch((error) => {
                  console.error(error);
                  if (error.message) {
                    this.setState({
                      insertmessage: error.message,
                      isSaving: false,
                    });
                  }
                });
            })
            .catch((response) => {
              if (response.message) {
                this.setState({
                  insertmessage: response.message,
                  isSaving: false,
                });
              }
            });
        }
      }
      // if (flag === 1) {
      //   Router.push(
      //     { pathname: "/RegMain", asPath: "/RegMain", query: values },
      //     "/RegMain"
      //   );
      // }
    } else if (id === "fmodal") {
      let regularExpression = new RegExp("^(?=.*[a-z])(?=.*[0-9])(?=.{8,})");
      if (this.state.verificationdisplay === false) {
        this.setState({ isSaving: true });
        localStorage.setItem("auth_query", JSON.stringify(values));
        var flag = 1;
        this.setState({
          f_email_err_status: false,
          f_email_err_msg: "",
        });
        if (values && values.email === "") {
          flag = 0;
          this.setState({
            f_email_err_status: true,
            f_email_err_msg: "Email is required!",
          });
        } else {
          this.resetPassword(values.email);
        }
      } else {
        if (values && values.email === "") {
          flag = 0;
          this.setState({
            f_email_err_status: true,
            f_email_err_msg: "Email is required!",
          });
        }

        if (values && values.verificationcode === "") {
          this.setState({
            f_veri_err_status: true,
            f_veri_err_msg: "Verification code required!",
          });
        }

        if (values && values.newpass === "") {
          this.setState({
            f_pass_err_status: true,
            f_pass_err_msg: "Please enter new password!",
          });
        }

        if (!regularExpression.test(values.newpass)) {
          this.setState({
            f_pass_err_status: true,
            f_pass_txt: "",
            f_pass_err_msg:
              "Password must be at least 8 characters in legth and contain at least 1 alphabetical character and 1 number. Do not use the $ symbol at the beginning or end of the password",
          });
        }
        if (values.newpass.slice(-1) === "$") {
          this.setState({
            f_pass_err_status: true,
            f_pass_txt: "",
            f_pass_err_msg:
              "Do not use the $ symbol at the beginning or end of the password",
          });
        }

        if (
          values.email != "" &&
          values.verificationcode != "" &&
          values.newpass != ""
        ) {
          this.setState({ isSaving: true });
          this.resetPasswordsubmit(
            values.email,
            values.verificationcode,
            values.newpass,
          );
        }
      }
    }
  };
  redirectTolastpage = () => {
    const lasturl = localStorage.getItem("previous_url");
    window.location.href = lasturl;
  };
  refiectTonhpage = (email) => {
    const isfromreview = localStorage.getItem("isfromnhreview");
    const isfromques = localStorage.getItem("isfromques");
    const isfromCityreview = localStorage.getItem("isfromCityreview");

    if (
      (isfromreview || isfromCityreview) &&
      (isfromreview !== null || isfromCityreview !== null) &&
      (isfromreview != undefined || isfromCityreview !== undefined)
    ) {
      this.addreviewData(email);
      //window.location.href = lasturl;
    } else if (isfromques && isfromques !== null && isfromques != undefined) {
      localStorage.removeItem("isfromques");
      this.addQuesData(email);
    } else {
      //window.location.href = lasturl;
    }
  };
  addQuesData = (email) => {
    const getdata = {
      start: 0,
      limit: 10,
      orderBy: "email",
      order: "ASC",
      fields: [{ name: "email", value: email, operator: "=" }],
    };
    getAllUserList(getdata).then((result) => {
      if (result.data.getUser.length > 0) {
        if (localStorage.quesData && localStorage.quesData != undefined) {
          const getQuesData = JSON.parse(localStorage.quesData);
          const adddata = {
            userId: result.data.getUser[0].id,
            neighborhoodId: getQuesData.neighborhoodId,
            question: getQuesData.question,
            postedDate: new Date(),
            updatedDate: new Date(),
            lastUpdated: new Date(),
          };
          const addCitydata = {
            userId: result.data.getUser[0].id,
            cityName: getQuesData.cityName,
            question: getQuesData.question,
            postedDate: new Date(),
            updatedDate: new Date(),
            lastUpdated: new Date(),
          };
          let editor_emails = editorData.toString();
          const subject = "A new Question is Posted";
          var clink =
            window.location.protocol +
            "//" +
            window.location.host +
            "/City/" +
            getQuesData.cityName;
          var nhlink =
            window.location.protocol +
            "//" +
            window.location.host +
            "/Neighborhood/" +
            getQuesData.nhfullname;
          let chmsg = `A new Question is posted in city <a href="${clink}" target="_blank">${getQuesData.cityName}</a>`;
          var nhmsg = `A new Question is posted in neighborhood <a href="${nhlink}" target="_blank">${getQuesData.label}</a>`;
          var editormsg = getQuesData.cityName ? chmsg : nhmsg;

          if (
            getQuesData.cityName &&
            getQuesData.cityName !== undefined &&
            getQuesData.cityName != null
          ) {
            cityaddquestion(addCitydata)
              .then((result) => {
                localStorage.removeItem("quesData");
                localStorage.removeItem("isfromques");
                this.sendNotification(
                  subject,
                  editormsg,
                  editor_emails,
                  getQuesData.userId,
                );
              })
              .catch((err) => {});
          } else {
            addquestion(adddata)
              .then((result) => {
                localStorage.removeItem("quesData");
                localStorage.removeItem("isfromques");
                this.sendNotification(
                  subject,
                  editormsg,
                  editor_emails,
                  getQuesData.neighborhoodId,
                );
              })
              .catch((err) => {});
          }
        }
      }
    });
  };

  addreviewData = (email) => {
    const getdata = {
      start: 0,
      limit: 10,
      orderBy: "email",
      order: "ASC",
      fields: [{ name: "email", value: email, operator: "=" }],
    };
    getAllUserList(getdata).then((result) => {
      if (result.data.getUser.length > 0) {
        if (localStorage.reviewData && localStorage.reviewData != undefined) {
          const getReviewData = JSON.parse(localStorage.reviewData);
          const adddata = {
            NeighborhoodID: getReviewData.neighborhoodId,
            UserID: result.data.getUser[0].id,
            author:
              result.data.getUser[0].firstName +
              " " +
              result.data.getUser[0].lastName,
            createDate: new Date(),
            helpfulCount: 0,
            heading: getReviewData.heading,
            description: getReviewData.description,
            communityRating: 0,
            publicSpacesRating: getReviewData.publicspace || 0,
            curbAppealRating: getReviewData.curb || 0,
            jobsRating: 0,
            keywords: "",
            greatfor: "",
            summary: "",
            editor_rate: 0,
          };
          const addcitydata = {
            cityname: getReviewData.cityname,
            UserID: result.data.getUser[0].id,
            author:
              result.data.getUser[0].firstName +
              " " +
              result.data.getUser[0].lastName,
            createDate: new Date(),
            helpfulCount: 0,
            heading: getReviewData.heading,
            description: getReviewData.description,
            communityRating: 0,
            publicSpacesRating: getReviewData.publicspace || 0,
            curbAppealRating: getReviewData.curb || 0,
            jobsRating: 0,
            keywords: "",
            greatfor: "",
            summary: "",
            editor_rate: 0,
          };
          let editor_emails = getReviewData.cityFullName
            ? cityeditorData.toString()
            : editorData.toString();
          var subject = "A new Review is posted";
          var clink =
            window.location.protocol +
            "//" +
            window.location.host +
            "/City/" +
            getReviewData.cityFullName;
          var nhlink =
            window.location.protocol +
            "//" +
            window.location.host +
            "/Neighborhood/" +
            getReviewData.nhfullname;
          let chmsg = `A new Review is posted in city <a href="${clink}" target="_blank">${getReviewData.cityFullName}</a>`;
          let nhmsg = `A new Review is posted in neighborhood <a href="${nhlink}" target="_blank">${getReviewData.label}</a>`;
          var editormsg = getReviewData.cityFullName ? chmsg : nhmsg;
          if (
            getReviewData.cityFullName &&
            getReviewData.cityFullName !== null &&
            getReviewData.cityFullName != undefined
          ) {
            addcityreview(addcitydata)
              .then((result) => {
                this.sendNotification(
                  subject,
                  editormsg,
                  editor_emails,
                  getReviewData.UserID,
                );
                localStorage.removeItem("reviewData");
                // localStorage.removeItem("isfromnhreview");
              })
              .catch((err) => {});
          } else {
            addneighborhoodreview(adddata)
              .then((result) => {
                this.sendNotification(
                  subject,
                  editormsg,
                  editor_emails,
                  getReviewData.neighborhoodId,
                );
                localStorage.removeItem("reviewData");
                // localStorage.removeItem("isfromnhreview");
              })
              .catch((err) => {});
          }
        }
      }
    });
  };

  sendNotification(subject, editormsg, editor_emails, neighborhoodId) {
    const noti_data = {
      subject: subject,
      message: editormsg,
      userId: editor_emails,
      neighborhoodId: neighborhoodId,
      questionid: "editor",
    };

    sendNotification(noti_data)
      .then((result) => {
        localStorage.removeItem("reviewData");
        localStorage.removeItem("quesData");
        localStorage.removeItem("isfromques");
        if (this.state.isFromReview) {
          const lasturl = localStorage.getItem("previous_url");
          window.location.href = lasturl;
        }
        if (this.state.isFromCReview) {
          const lasturl = localStorage.getItem("previous_url");
          window.location.href = lasturl;
        }
      })
      .catch((error) => {});
  }
  resetPassword(username) {
    const getdata = {
      start: 0,
      limit: 10,
      orderBy: "email",
      order: "ASC",
      fields: [{ name: "email", value: username, operator: "=" }],
    };
    getAllUserList(getdata)
      .then((result) => {
        if (result.data.getUser.length > 0) {
          this.setState({ isSaving: false });
          resetPassword({ username })
            .then((data) => {
              this.setState({
                f_email_success: true,
                f_email_success_msg: "Verification code sent to your email",
                verificationdisplay: true,
                newpassword: true,
              });
            })
            .catch((err) => {});
        } else {
          this.setState({
            f_email_err_status: true,
            f_email_err_msg:
              "Your email is not register with us. Please use register email address",
            isSaving: false,
          });
        }
      })
      .catch((error) => {
        this.setState({ isSaving: false });
        console.error(error);
      });
  }

  resetPasswordsubmit(username, code, new_password) {
    this.setState({ changemsg: "" });
    confirmResetPassword({
      username,
      confirmationCode: code,
      newPassword: new_password,
    })
      .then((data) => {
        //update in database
        const updatedata = {
          email: username,
          password: new_password,
        };
        updateUserpassword(updatedata)
          .then((result) => {
            if (result.data.UpdateUserpassword.success === true) {
              this.setState({
                smodal: false,
                lmodal: true,
                fmodal: false,
                isSaving: false,
              });
            } else if (result.data.UpdateUser.success === false) {
              this.setState({
                changemsg: "Something Getting Wrong",
                isSaving: false,
              });
            }
          })
          .catch((error) => {
            console.error(error);
          });
      })
      .catch((err) => {
        this.setState({ changemsg: err.message, isSaving: false });
      });
  }

  handlelength = (val) => {
    this.newsuggestion_length = val;
  };

  onChangeCheckbox = (event) => {
    this.setState({
      isChecked: event.target.checked,
    });
  };
  onChangeAgentCheckbox = (event) => {
    this.setState({
      isAgentChecked: event.target.checked,
    });
  };
  closeModalsucess = () => {
    this.setState({ ismodalopen: false });
    // window.location.href = "/login";
  };
  closeModalque = () => {
    this.setState({ ismodalopenque: false });
    const lasturl = localStorage.getItem("previous_url");
    window.location.href = lasturl;
  };
  closeModalreview = () => {
    this.setState({ ismodalopenreview: false });
    const lasturl = localStorage.getItem("previous_url");
    window.location.href = lasturl;
  };
  render() {
    let { places, lmodal, smodal, fmodal } = this.state;

    return (
      <>
        <Config />
        <Nav
          address={this.state.address}
          search={this.props.search}
          tagline={this.props.tagline}
          button={this.buttonClick}
          onChange={(event) => this.handleInputChange(event)}
          onClick={(event) => this.handleInputClick(event)}
          onSelect={(event) => this.handleAddressSelect(event)}
          username={this.state.username}
          returnemail={this.state.returnemail}
          page={this.state.page}
          nhmap={this.props.nhmap}
          resultdata={this.state.results}
          homeresultdata={this.state.homeresults}
          addresslength={this.state.address.length}
          displaydata={this.state.displaydata}
          loadingtext={this.state.loadingtext}
          onkeydown={this.handleKeyChange}
          userInput={this.state.userInput}
          newsuggestions={this.newsuggestions}
          newsuggestion_length={this.newsuggestion_length}
          activeSuggestion={this.state.activeSuggestion}
          showSuggestions={this.state.showSuggestions}
          handleSelect={this.handleSelect}
          inputRef={(el) => (this.inputElement = el)}
          handlelength={this.handlelength}
          ishome={this.state.ishome}
          redirecturl={this.state.redirecturl}
          gmapsLoaded={this.state.gmapsLoaded}
          bottomtabwidth={this.state.bottomtabwidth}
          load_header={this.state.load_header}
          homeclick={this.homeClick}
          searchref={this.search}
          handleoutsideclick={(e) => this.handleOutsideClick(e)}
          searchquery={this.state.query}
          is_loaded={this.state.is_loaded}
          handleCloseIconClick={() => this.handleCloseIconClick()}
        />
        <LoginModal
          iconclick={this.closeModal}
          open={lmodal}
          next={this.nextModal}
          submit={this.handleSubmit}
          email_err_status={this.state.email_err_status}
          email_err_msg={this.state.email_err_msg}
          pwd_err_status={this.state.pwd_err_status}
          pwd_err_msg={this.state.pwd_err_msg}
          onChangeCheckbox={this.onChangeCheckbox}
          isChecked={this.state.isChecked}
          emailval={this.state.emailval}
          passval={this.state.passval}
          user_confirm_status={this.state.user_confirm_status}
          isSaving={this.state.isSaving}
        />
        {this.props.children}
        <SignupModal
          iconclick={this.closeModal}
          open={smodal}
          next={this.nextModal}
          submit={this.handleSubmit}
          s_firstname_err_status={this.state.s_firstname_err_status}
          s_firstname_err_msg={this.state.s_firstname_err_msg}
          s_email_err_status={this.state.s_email_err_status}
          s_email_err_msg={this.state.s_email_err_msg}
          s_lastname_err_status={this.state.s_lastname_err_status}
          s_lastname_err_msg={this.state.s_lastname_err_msg}
          s_password_err_status={this.state.s_password_err_status}
          s_password_err_msg={this.state.s_password_err_msg}
          s_confirmpassword_err_status={this.state.s_confirmpassword_err_status}
          s_confirmpassword_err_msg={this.state.s_confirmpassword_err_msg}
          firstNameChage={this.firstNameChage}
          insertmessage={this.state.insertmessage}
          onChangeAgentCheckbox={this.onChangeAgentCheckbox}
          isAgentChecked={this.state.isAgentChecked}
          isSaving={this.state.isSaving}
        />
        <ForgotpasswordModal
          iconclick={this.closeModal}
          open={fmodal}
          next={this.nextModal}
          submit={this.handleSubmit}
          // email_err_status={this.state.email_err_status}
          // email_err_msg={this.state.email_err_msg}
          f_email_err_msg={this.state.f_email_err_msg}
          f_email_err_status={this.state.f_email_err_status}
          f_email_success={this.state.f_email_success}
          f_email_success_msg={this.state.f_email_success_msg}
          verificationdisplay={this.state.verificationdisplay}
          newpassword={this.state.newpassword}
          f_pass_err_status={this.state.f_pass_err_status}
          f_pass_err_msg={this.state.f_pass_err_msg}
          f_pass_txt={this.state.f_pass_txt}
          f_veri_err_status={this.state.f_veri_err_status}
          f_veri_err_msg={this.state.f_veri_err_msg}
          changemsg={this.state.changemsg}
          //pwd_err_status={this.state.pwd_err_status}
          //pwd_err_msg={this.state.pwd_err_msg}
          isSaving={this.state.isSaving}
        />
        {!this.state.isFromQues &&
          !this.state.isFromReview &&
          !this.state.isFromCReview && (
            <div className="success_modal">
              <Modal
                isOpen={this.state.ismodalopen}
                onRequestClose={this.closeModalsucess}
                style={customStyles}
              >
                <div className="review_model_close_btn">
                  <span onClick={this.closeModalsucess} className="">
                    <Icon link size="large" name="close" />
                  </span>
                </div>
                <div className="review-model-main">
                  <div>
                    <div className="model_ques_feedback">
                      Please Check Your Email and Click the Verification Link
                    </div>
                  </div>
                </div>
              </Modal>
            </div>
          )}
        {this.state.isFromQues && (
          <div className="success_modal">
            <Modal
              isOpen={this.state.ismodalopenque}
              onRequestClose={this.closeModalque}
              style={customStylesQue}
            >
              <div className="review-model-main">
                <div>
                  {this.state.isFromQues && (
                    <div className="model_ques_feedback">
                      Please check your email and click Verify to post your
                      question
                    </div>
                  )}
                </div>
              </div>

              {this.state.isFromQues && (
                <div className="review_model_close_btn">
                  <a onClick={this.closeModalque}>Close</a>
                </div>
              )}
            </Modal>
          </div>
        )}
        {(this.state.isFromReview || this.state.isFromCReview) && (
          <div className="success_modal">
            <Modal
              isOpen={this.state.ismodalopenreview}
              onRequestClose={this.closeModalreview}
              style={customStylesQue}
            >
              <div className="review-model-main">
                <div>
                  {(this.state.isFromReview || this.state.isFromCReview) && (
                    <div className="model_review_feedback">
                      Please check your email and click verify.{" "}
                      <p> Your review will be posted soon!</p>
                    </div>
                  )}
                </div>
              </div>
            </Modal>
          </div>
        )}
      </>
    );
  }
}

Layout.propTypes = {
  children: PropTypes.any,
  search: PropTypes.bool,
};

export default Layout;

export async function getStaticProps(context) {
  const query = context.params || {};
  return {
    props: { query },
  };
}
